import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BuyerManagementTab = () => {
  const [activeSection, setActiveSection] = useState('onboarding');
  const [showOnboardingForm, setShowOnboardingForm] = useState(false);

  // Mock data for buyers
  const buyers = [
    {
      id: 1,
      name: 'Siddharth Retail Pvt Ltd',
      contactPerson: 'Mr. Siddharth Sharma',
      email: 'siddharth@retailpvt.com',
      phone: '+91 98765 43210',
      gstin: '27AABCS1234F1Z5',
      pan: 'AABCS1234F',
      address: 'Shop 12, Market Area, Pune - 411001',
      status: 'active',
      onboardedDate: '2025-10-15',
      totalPurchases: 45,
      totalValue: 17250000,
      documents: {
        gst: { status: 'verified', uploadDate: '2025-10-12' },
        pan: { status: 'verified', uploadDate: '2025-10-12' },
        addressProof: { status: 'verified', uploadDate: '2025-10-13' },
        bankDetails: { status: 'verified', uploadDate: '2025-10-13' }
      }
    },
    {
      id: 2,
      name: 'Prasad Enterprises',
      contactPerson: 'Mr. Prasad Kulkarni',
      email: 'prasad@enterprises.com',
      phone: '+91 97654 32109',
      gstin: '27AABCP5678G1Z6',
      pan: 'AABCP5678G',
      address: '45, Industrial Estate, Mumbai - 400001',
      status: 'pending',
      onboardedDate: '2025-11-28',
      totalPurchases: 0,
      totalValue: 0,
      documents: {
        gst: { status: 'pending', uploadDate: '2025-11-28' },
        pan: { status: 'verified', uploadDate: '2025-11-28' },
        addressProof: { status: 'pending', uploadDate: null },
        bankDetails: { status: 'pending', uploadDate: null }
      }
    },
    {
      id: 3,
      name: 'Vijay Traders',
      contactPerson: 'Mr. Vijay Deshmukh',
      email: 'vijay@traders.com',
      phone: '+91 99876 54321',
      gstin: '27AABCV9876H1Z7',
      pan: 'AABCV9876H',
      address: 'Plot 8, Trading Complex, Sangli - 416416',
      status: 'active',
      onboardedDate: '2025-09-20',
      totalPurchases: 78,
      totalValue: 32450000,
      documents: {
        gst: { status: 'verified', uploadDate: '2025-09-18' },
        pan: { status: 'verified', uploadDate: '2025-09-18' },
        addressProof: { status: 'verified', uploadDate: '2025-09-19' },
        bankDetails: { status: 'verified', uploadDate: '2025-09-19' }
      }
    },
    {
      id: 4,
      name: 'Rohit Sugar Distributors',
      contactPerson: 'Mr. Rohit Patil',
      email: 'rohit@sugardist.com',
      phone: '+91 98234 56789',
      gstin: '27AABCR4567I1Z8',
      pan: 'AABCR4567I',
      address: 'Warehouse 15, Storage Complex, Kolhapur - 416005',
      status: 'active',
      onboardedDate: '2025-08-10',
      totalPurchases: 112,
      totalValue: 48750000,
      documents: {
        gst: { status: 'verified', uploadDate: '2025-08-08' },
        pan: { status: 'verified', uploadDate: '2025-08-08' },
        addressProof: { status: 'verified', uploadDate: '2025-08-09' },
        bankDetails: { status: 'verified', uploadDate: '2025-08-09' }
      }
    }
  ];

  const getStatusColor = (status) => {
    switch(status) {
      case 'active': return 'text-green-600 bg-green-100';
      case 'pending': return 'text-yellow-600 bg-yellow-100';
      case 'suspended': return 'text-red-600 bg-red-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const getDocStatusColor = (status) => {
    switch(status) {
      case 'verified': return 'text-green-600 bg-green-100';
      case 'pending': return 'text-yellow-600 bg-yellow-100';
      case 'rejected': return 'text-red-600 bg-red-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const activeBuyers = buyers?.filter(b => b?.status === 'active')?.length;
  const pendingBuyers = buyers?.filter(b => b?.status === 'pending')?.length;
  const totalPurchases = buyers?.reduce((sum, b) => sum + b?.totalPurchases, 0);
  const totalValue = buyers?.reduce((sum, b) => sum + b?.totalValue, 0);

  return (
    <div className="space-y-6">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
              <Icon name="Users" size={20} className="text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Buyers</p>
              <p className="text-2xl font-bold text-foreground">{buyers?.length}</p>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
              <Icon name="CheckCircle2" size={20} className="text-green-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Active Buyers</p>
              <p className="text-2xl font-bold text-foreground">{activeBuyers}</p>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-yellow-100 flex items-center justify-center">
              <Icon name="Clock" size={20} className="text-yellow-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Pending</p>
              <p className="text-2xl font-bold text-foreground">{pendingBuyers}</p>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
              <Icon name="IndianRupee" size={20} className="text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Value</p>
              <p className="text-2xl font-bold text-foreground">₹{(totalValue / 10000000)?.toFixed(1)}Cr</p>
            </div>
          </div>
        </div>
      </div>
      {/* Section Tabs */}
      <div className="bg-card rounded-lg border border-border">
        <div className="flex items-center gap-2 p-2 border-b border-border">
          <button
            onClick={() => setActiveSection('onboarding')}
            className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
              activeSection === 'onboarding' ?'bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white' :'text-muted-foreground hover:bg-muted'
            }`}
          >
            <Icon name="UserPlus" size={18} />
            <span>Buyer Onboarding</span>
          </button>
          <button
            onClick={() => setActiveSection('management')}
            className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
              activeSection === 'management' ?'bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white' :'text-muted-foreground hover:bg-muted'
            }`}
          >
            <Icon name="Users" size={18} />
            <span>Buyer Management</span>
          </button>
        </div>

        <div className="p-6">
          {activeSection === 'onboarding' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">Onboard New Buyer</h3>
                  <p className="text-sm text-muted-foreground">
                    Complete documentation process for new buyer registration
                  </p>
                </div>
                <Button
                  className="bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white"
                  onClick={() => setShowOnboardingForm(!showOnboardingForm)}
                >
                  <Icon name="Plus" size={18} />
                  <span>New Buyer</span>
                </Button>
              </div>

              {showOnboardingForm && (
                <div className="bg-background rounded-lg border border-border p-6">
                  <h4 className="text-md font-semibold text-foreground mb-4">Buyer Information</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Company Name *
                      </label>
                      <input
                        type="text"
                        placeholder="Enter company name"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Contact Person *
                      </label>
                      <input
                        type="text"
                        placeholder="Enter contact person name"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        placeholder="Enter email address"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Phone *
                      </label>
                      <input
                        type="tel"
                        placeholder="Enter phone number"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        GSTIN *
                      </label>
                      <input
                        type="text"
                        placeholder="Enter GSTIN"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        PAN *
                      </label>
                      <input
                        type="text"
                        placeholder="Enter PAN"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Address *
                      </label>
                      <textarea
                        rows={3}
                        placeholder="Enter complete address"
                        className="w-full px-4 py-2 bg-card border border-border rounded-lg focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] text-foreground"
                      />
                    </div>
                  </div>

                  <div className="mt-6">
                    <h4 className="text-md font-semibold text-foreground mb-4">Document Upload</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {['GST Certificate', 'PAN Card', 'Address Proof', 'Bank Details']?.map((doc, idx) => (
                        <div key={idx} className="border-2 border-dashed border-border rounded-lg p-4 text-center hover:border-[#ff8c00] transition-all cursor-pointer">
                          <Icon name="Upload" size={32} className="text-muted-foreground mx-auto mb-2" />
                          <p className="text-sm font-medium text-foreground mb-1">{doc}</p>
                          <p className="text-xs text-muted-foreground">Click to upload or drag and drop</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex gap-3 mt-6">
                    <Button
                      className="flex-1 bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white"
                      onClick={() => {}}
                    >
                      Submit for Verification
                    </Button>
                    <Button
                      variant="outline"
                      className="flex-1"
                      onClick={() => setShowOnboardingForm(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

              <div>
                <h4 className="text-md font-semibold text-foreground mb-3">Required Documents</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {[
                    { name: 'GST Certificate', desc: 'Valid GST registration certificate' },
                    { name: 'PAN Card', desc: 'Company PAN card copy' },
                    { name: 'Address Proof', desc: 'Utility bill or lease agreement' },
                    { name: 'Bank Details', desc: 'Cancelled cheque or bank statement' }
                  ]?.map((doc, idx) => (
                    <div key={idx} className="flex items-start gap-3 p-3 bg-background rounded-lg border border-border">
                      <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                        <Icon name="FileText" size={16} className="text-blue-600" />
                      </div>
                      <div>
                        <p className="font-medium text-foreground text-sm">{doc?.name}</p>
                        <p className="text-xs text-muted-foreground">{doc?.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeSection === 'management' && (
            <div className="space-y-4">
              {buyers?.map((buyer) => (
                <div key={buyer?.id} className="bg-background rounded-lg border border-border p-6">
                  <div className="flex flex-col lg:flex-row gap-6">
                    {/* Buyer Info */}
                    <div className="lg:w-1/3 border-r border-border pr-6">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-foreground mb-1">{buyer?.name}</h3>
                          <p className="text-sm text-muted-foreground mb-2">{buyer?.contactPerson}</p>
                          <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(buyer?.status)}`}>
                            {buyer?.status?.charAt(0)?.toUpperCase() + buyer?.status?.slice(1)}
                          </span>
                        </div>
                      </div>

                      <div className="space-y-2 text-sm mb-4">
                        <div className="flex items-center gap-2">
                          <Icon name="Mail" size={16} className="text-muted-foreground" />
                          <span className="text-foreground break-all">{buyer?.email}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Icon name="Phone" size={16} className="text-muted-foreground" />
                          <span className="text-foreground">{buyer?.phone}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Icon name="MapPin" size={16} className="text-muted-foreground" />
                          <span className="text-foreground">{buyer?.address}</span>
                        </div>
                      </div>

                      <div className="space-y-2 text-sm mb-4">
                        <div className="flex items-center justify-between">
                          <span className="text-muted-foreground">GSTIN:</span>
                          <span className="font-medium text-foreground">{buyer?.gstin}</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-muted-foreground">PAN:</span>
                          <span className="font-medium text-foreground">{buyer?.pan}</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-muted-foreground">Onboarded:</span>
                          <span className="font-medium text-foreground">
                            {new Date(buyer.onboardedDate)?.toLocaleDateString()}
                          </span>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-3">
                        <div className="text-center p-3 bg-card rounded-lg border border-border">
                          <p className="text-xs text-muted-foreground mb-1">Total Orders</p>
                          <p className="text-lg font-bold text-foreground">{buyer?.totalPurchases}</p>
                        </div>
                        <div className="text-center p-3 bg-card rounded-lg border border-border">
                          <p className="text-xs text-muted-foreground mb-1">Total Value</p>
                          <p className="text-lg font-bold text-green-600">
                            ₹{(buyer?.totalValue / 100000)?.toFixed(1)}L
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Documents Status */}
                    <div className="lg:w-2/3">
                      <h4 className="text-md font-semibold text-foreground mb-4">Document Status</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {Object.entries(buyer?.documents)?.map(([docType, docInfo]) => (
                          <div key={docType} className="p-4 bg-card rounded-lg border border-border">
                            <div className="flex items-start justify-between mb-3">
                              <div className="flex items-center gap-2">
                                <Icon name="FileText" size={18} className="text-muted-foreground" />
                                <p className="font-medium text-foreground capitalize">
                                  {docType?.replace(/([A-Z])/g, ' $1')?.trim()}
                                </p>
                              </div>
                              <span className={`px-2 py-1 rounded text-xs font-medium ${getDocStatusColor(docInfo?.status)}`}>
                                {docInfo?.status}
                              </span>
                            </div>
                            {docInfo?.uploadDate && (
                              <p className="text-xs text-muted-foreground">
                                Uploaded: {new Date(docInfo.uploadDate)?.toLocaleDateString()}
                              </p>
                            )}
                            <div className="flex gap-2 mt-3">
                              <Button size="sm" variant="outline" className="flex-1">
                                <Icon name="Eye" size={14} />
                                View
                              </Button>
                              {docInfo?.status === 'pending' && (
                                <>
                                  <Button size="sm" className="flex-1 bg-green-600 text-white hover:bg-green-700">
                                    <Icon name="Check" size={14} />
                                    Approve
                                  </Button>
                                  <Button size="sm" className="flex-1 bg-red-600 text-white hover:bg-red-700">
                                    <Icon name="X" size={14} />
                                    Reject
                                  </Button>
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="flex gap-3 mt-6">
                        <Button
                          variant="outline"
                          className="flex-1"
                          onClick={() => {}}
                        >
                          <Icon name="Mail" size={18} />
                          <span>Send Message</span>
                        </Button>
                        <Button
                          variant="outline"
                          className="flex-1"
                          onClick={() => {}}
                        >
                          <Icon name="FileText" size={18} />
                          <span>View History</span>
                        </Button>
                        {buyer?.status === 'pending' && (
                          <Button
                            className="flex-1 bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white"
                            onClick={() => {}}
                          >
                            <Icon name="CheckCircle2" size={18} />
                            <span>Activate</span>
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BuyerManagementTab;